import PropTypes from 'prop-types';
import React from 'react';

import ApolloWrapper from 'pages/LandingPage/ApolloWrapper';
import Main          from './Main';
import Company       from 'records/company';

import { SnackbarProvider, useSnackbar } from 'notistack';

function ListingsPage({ company }) {
  return (
    <>
      <Main company={company} />
    </>
  );
}

function ListingsPageApollo({ token, companyJson }) {

  const company  = new Company(JSON.parse(companyJson));

  return (
    <ApolloWrapper token={token}>
      <ListingsPage company={company} />
    </ApolloWrapper>
  );
}

ListingsPageApollo.defaultProps = {
  token:       null,
  companyJson: null,
};

ListingsPageApollo.propTypes = {
  token:       PropTypes.string,
  companyJson: PropTypes.string
};

export default ListingsPageApollo;
